import React from 'react';
import { Container, Row } from 'shards-react';

import Errors from '../../../components/Errors';
import GenericSearchBar from '../../../components/common/GenericSearchBar/GenericSearchBar';
import EstablishmentNumberInput from '../../../components/inputs/EstablishmentNumberInput';
import AccountNameOrIdInput from '../../../components/inputs/AccountNameOrIdInput';
import ShopNameInput from '../../../components/inputs/ShopNameInput';
import UserEmailInput from '../../../components/inputs/UserEmailInput';
import PageTitle from '../../../components/PageTitle';
import Constants from '../../../data/Constants';
import { useEstablishments } from '../../../hooks/queries/useEstablishments';
import { useUrlState } from '../../../hooks/useUrlState';
import { positiveIntegerParam, stringParam } from '../../../utils/urlStateParams';
import Table from './Table';
import ActionBar from '../../../components/common/ActionBar';

const inputs = [EstablishmentNumberInput, UserEmailInput, AccountNameOrIdInput, ShopNameInput];
const actions = [{ route: '/admin/establishments/new', label: 'Crear nuevo establecimiento' }];

const URL_STATE_CONFIG = {
  accountNameOrId: stringParam(),
  establishmentNumberOrId: stringParam(),
  page: positiveIntegerParam(),
  shopName: stringParam(),
  userEmail: stringParam()
};

const List = () => {
  const [urlState, setUrlState] = useUrlState(URL_STATE_CONFIG);
  const offset = (urlState.page - 1) * Constants.elementsPerPage;
  const filter = {
    accountNameOrId: urlState.accountNameOrId || undefined,
    establishmentNumberOrId: urlState.establishmentNumberOrId || undefined,
    shopName: urlState.shopName || undefined,
    userEmail: urlState.userEmail || undefined
  };
  const { establishments, loading, error } = useEstablishments(filter, {
    limit: Constants.elementsPerPage,
    offset
  });

  const onSubmit = (newFilter) => {
    setUrlState({
      accountNameOrId: newFilter.accountNameOrId?.trim() || '',
      establishmentNumberOrId: newFilter.establishmentNumberOrId?.trim() || '',
      shopName: newFilter.shopName?.trim() || '',
      userEmail: newFilter.userEmail?.trim() || '',
      page: 1
    });
  };

  const handlePageClick = (direction) => {
    const page = urlState.page + direction;
    if (page >= 1) setUrlState({ page });
  };

  return (
    <Container className="main-content-container px-4" fluid>
      <Row className="page-header py-4" noGutters>
        <PageTitle className="text-sm-left" sm="4" subtitle="" title="Establecimientos" />
      </Row>
      <GenericSearchBar
        handleSubmit={onSubmit}
        inputs={inputs}
        loading={loading}
        values={urlState}
      />
      <ActionBar items={actions} />
      <Errors errors={error ? ['No se pudieron cargar los establecimientos.'] : null} />
      <Table
        disableNext={establishments.length < Constants.elementsPerPage}
        disablePrev={urlState.page === 1}
        establishments={establishments}
        loading={loading}
        onPageClick={handlePageClick}
      />
    </Container>
  );
};

export default List;
